import { Button } from "@shapr3d/frontend-lib";

import useNavigation from "../../hooks/navigation";
import { NewZendeskTicketLink } from "../NewZendeskTicketLink/NewZendeskTicketLink";

import style from "./VerifyEmailConfirmation.module.css";

interface VerifyEmailConfirmationProps {
  success: boolean;
  edu: boolean;
}

const VerifyEmailConfirmation: React.FC<VerifyEmailConfirmationProps> = ({ success, edu }) => {
  const { goToProfile } = useNavigation();
  return (
    <div className={style.container}>
      <img
        src="https://s3-eu-west-1.amazonaws.com/shapr3d-assets/images/engine-model.png"
        alt="illustration"
        className={style.illustration}
      />
      <div className={style.message}>
        {success ? (
          <>
            {!edu && <div>It worked! Your email address was successfully confirmed!</div>}
            {edu && <div>All set! Your EDU license is now active.</div>}
          </>
        ) : (
          <>
            <div>Something went wrong. Please try again or follow </div>
            <NewZendeskTicketLink>
              <span className={style.link}>this link</span>
            </NewZendeskTicketLink>{" "}
            to submit a support ticket.
          </>
        )}
      </div>
      <Button onClick={() => goToProfile()}>Back to my profile</Button>
      {edu && (
        <div className={style.disclaimer}>
          If you already have a Pro trial running, <strong>you need to cancel it manually.</strong>
          <br />
          Otherwise, you&apos;ll be charged at the end of the trial regardless of your EDU license.
        </div>
      )}
    </div>
  );
};

export default VerifyEmailConfirmation;
